<template>

    <form autocomplete="off" class="trax-form mb-4">

        <trax-ui-select :placeholder="lang.polaris.dashboard.location" 
            v-model="form.entity_id" :error="errors.entity_id" :options="locations_select" 
            grouped="1" col="md-3">
        </trax-ui-select>

        <trax-ui-datetime :placeholder="lang.polaris.dashboard.date" col="md-3"
            v-model="form.date" :error="errors.date" type="date" required="1">
        </trax-ui-datetime>

    </form>

</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-level-report-learner-edit'},
            source: {default: '1'},
            target: {default: '2'}
        },

        data: function() {
            return {
                lang: lang,
                phase: data.phase,
                locations_select: data.locations_select,
                locations_names_id: data.locations_names_id,
                locations_uuid_id: data.locations_uuid_id,
                locations_id_uuid: data.locations_id_uuid,
                default_location: data.phase.custom && data.phase.custom.entity_id ? data.phase.custom.entity_id : data.phase.entity_id,
                form: {
                    entity_id: null,
                    date: '',
                },
                errors: {},
                bus: this.$bus
            }
        },
        
        created: function() {
            this.bus.$on(this.id+'-states-data', this.setStates);
            this.bus.$on(this.id+'-states-updated', this.setStates);
            this.bus.$on(this.id+'-'+this.source+'-states-save', this.saveData);
            this.bus.$on(this.id+'-states-errors', this.setErrors);
        },

        methods: {

            setStates(states) {
                if (!states.summary) {
                    this.form.entity_id = this.default_location
                    this.form.date = '';
                    return;
                }
                if (states.summary.data.location) {
                    this.form.entity_id = this.locations_id_uuid[states.summary.data.location.entity_uuid];
                }
                this.form.date = states.summary.data.date;
            },

            setErrors(errors) {
                var my_errors = {};
                for (var index in errors) {
                    my_errors[index.split('.')[1]] = errors[index];
                }
                this.errors = my_errors;
            },

            saveData(data) {
                this.errors = {};
                for (var prop in this.form) { 
                    if (prop == 'entity_id') data.summary.location = {
                        entity_uuid: this.locations_uuid_id[this.form.entity_id], 
                        entity_name: this.locations_names_id[this.form.entity_id] 
                    };
                    else data.summary[prop] = this.form[prop]; 
                }
                this.bus.$emit(this.id+'-'+this.target+'-states-save', data);
            }
        }
    }
</script>
